export const DROP_LAST_VISITED = 'drop_last_page_visited';
